// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const FeaturedCars = () => {
//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 800,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 4000,
//     responsive: [
//       { breakpoint: 1000, settings: { slidesToShow: 2 } },
//       { breakpoint: 768, settings: { slidesToShow: 1 } },
//     ],
//   };

//   const cars = [
//     {
//       image: "/images/featured-car/featured-car-1.jpg",
//       title: "Toyota Land Cruiser",
//       price: "$49 / Day",
//       rating: "4.8",
//       text: "Three-row SUV with a modern design, upscale interior, and a plethora of safety.",
//     },
//     {
//       image: "/images/featured-car/featured-car-2.jpg",
//       title: "Nissan GTR Turbo",
//       price: "$49 / Day",
//       rating: "4.8",
//       text: "Iconic muscle car with classic power, strong engines, and agile handling.",
//     },
//     {
//       image: "/images/featured-car/featured-car-3.jpg",
//       title: "Mitsubishi Portan",
//       price: "$49 / Day",
//       rating: "4.8",
//       text: "Robust full-size pickup truck with powerful towing capabilities.",
//     },
//     {
//       image: "/images/featured-car/featured-car-1.jpg",
//       title: "Toyota Land Cruiser",
//       price: "$49 / Day",
//       rating: "4.8",
//       text: "Three-row SUV with a modern design, upscale interior, and a plethora of safety.",
//     },
//   ];

//   return (
//     <section className="featured-car-section pt_120 pb_90">
//       <div className="container">
//         <div className="section-title centred mb_60">
//           <span className="sub-title">Featured Cars</span>
//           <h2 className="title">Featured Cars</h2>
//         </div>

//         <Slider {...settings}>
//           {cars.map((car, index) => (
//             <div className="single-featured-car-block" key={index}>
//               <div className="single-featured-car-image">
//                 <a href="#">
//                   <img src={car.image} alt={car.title} />
//                 </a>
//                 <div className="single-featured-car-rent-per-day">
//                   <span>{car.price.split(" ")[0]}</span> / Day
//                 </div>
//               </div>
//               <div className="single-featured-car-content">
//                 <div className="single-featured-car-rating">
//                   <i className="icon-9"></i>{car.rating}
//                 </div>
//                 <h5 className="single-featured-car-title">
//                   <a href="#">{car.title}</a>
//                 </h5>
//                 <p className="single-featured-car-text">{car.text}</p>
//                 <div className="border-divider"></div>
//                 <ul className="single-featured-car-info">
//                   <li><i className="icon-6"></i>Doors: 2 Doors</li>
//                   <li><i className="icon-7"></i>Suitcase: 1 Large, 2 Small</li>
//                   <li><i className="icon-8"></i>Passengers: 06</li>
//                 </ul>
//                 <div className="single-featured-car-book-btn">
//                   <a href="#" className="btn-style-three">Rent now</a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </section>
//   );
// };

// export default FeaturedCars;


import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const routes = [
  {
    image: "/images/newimages/7.jpg",
    title: "Pune to Shirdi Cabs Hire",
    description:
      "Sai Trupti Cabs offers comfortable and affordable cab hire services with experienced drivers and well-maintained vehicles. Whether you're visiting for pilgrimage or leisure, travel safely and conveniently with us.",
  },
  {
    image: "/images/keyword/52.jpg",
    title: "Pune to Goa Cab",
    description:
      "Sai Trupti Cabs offers reliable and comfortable cab services with professional drivers and well-maintained vehicles. Whether you're traveling with family, friends, or solo, enjoy a hassle-free and scenic journey to the sunny beaches of Goa.",
  },
  {
    image: "/images/keyword/17.jpg",
    title: "Kharadi to Mumbai Cab",
    description:
      "Planning a trip from Kharadi to Mumbai? Sai Trupti Cab offers reliable and convenient cab services with experienced drivers, clean vehicles, and affordable rates. Whether for business, leisure, or airport transfers, travel comfortably with us.",
  },
  {
    image: "/images/keyword/1.jpg",
    title: "Pune to Mumbai Cab",
    description:
      "Sai Trupti Cab offers dependable, affordable, and comfortable cab services for one-way and round trips. Whether you're heading to the airport or a weekend getaway, enjoy smooth and timely rides with professional drivers.",
  },
  {
    image: "/images/newkey/2.jpg",
    title: "Mumbai to Pune Daily Cab",
    description:
      "Sai Trupti Cabs offers dependable and affordable daily cab services for regular commuters, business travelers, and students. We provide on-time pickups, professional drivers, and well-maintained vehicles on the Mumbai–Pune route.",
  },
  {
    image: "/images/keyword/18.jpg",
    title: "Shivajinagar to Mumbai Cab",
    description:
      "Travel comfortably and safely from Shivajinagar to Mumbai with Sai Trupti Cab. Enjoy professional cab services with experienced drivers, clean vehicles, and affordable rates for every trip.",
  },
];

const RoutesSection = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="routes-section">
      <div className="container">
        <div className="section-title text-center">
          <span className="sub-title">Sai Trupti Cabs</span>
          <h2 className="title">Top Routes with Sai Trupti Cabs</h2>
        </div>

        <Slider {...settings}>
          {routes.map((route, index) => (
            <div key={index} className="route-card">
              <div className="route-image">
                <img src={route.image} alt={route.title} />
                <span className="badge">Sai Trupti Cabs</span>
              </div>
              <div className="route-content">
                <h4>{route.title}</h4>
                <p>{route.description}</p>
                <button
                  className="read-btn"
                  onClick={() =>
                    (window.location.href = `/booking?route=${encodeURIComponent(
                      route.title
                    )}`)
                  }
                >
                  Read More
                </button>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default RoutesSection;
